import { Button } from "../button";
import { cn } from "@/utils/cn";

export default function BtnCancel({
  children,
  className,
  ...props
}: { children: React.ReactNode; className?: string } & React.ComponentProps<
  typeof Button
>) {
  return (
    <Button
      variant={"outline"}
      className={cn(
        "rounded-full px-7 py-5 text-[15px] border-2 border-sig text-sig bg-transparent! hover:border-sig/80 hover:text-sig/80",
        className
      )}
      {...props}
    >
      {children}
    </Button>
  );
}
